import {createGate} from 'effector-react';

import {rootDomain} from 'core/rootDomain';

import {CodeResponseType} from 'types/validation';

const domain = rootDomain.createDomain('DocumentsChildCodesGridTableDomain');
export const Gate = createGate('ChildrenCodesGate');

export const dataChanged = domain.createEvent<CodeResponseType['info']>();
export const data$ = domain.createStore<CodeResponseType['info'][]>([]);
